module.exports = __webpack_public_path__ + "static/media/patients.9f162c47.svg";